import React from "react";

export const LinkButton =
	(p: React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>) =>
		<a
			{...p}
			className="btn btn-primary btn-block"
			role="button">
				{p.children}
		</a>;